import Config from 'APP/Config'
import { BROWNFIELD_BRIDGE_DEEPLINK_TYPE } from './deeplinkTypes'

export const DEEPLINK_ROUTE_TEMPLATES = {
  [BROWNFIELD_BRIDGE_DEEPLINK_TYPE.episode]: '/episode/:episodeId',
  [BROWNFIELD_BRIDGE_DEEPLINK_TYPE.services]: '/services',
  [BROWNFIELD_BRIDGE_DEEPLINK_TYPE.physicalHealth]: '/physical-health',
  [BROWNFIELD_BRIDGE_DEEPLINK_TYPE.mentalHealth]: '/mental-health',
  [BROWNFIELD_BRIDGE_DEEPLINK_TYPE.diabetesCare]: '/diabetes-care',
  [BROWNFIELD_BRIDGE_DEEPLINK_TYPE.respiratoryCare]: '/respiratory-care',
  [BROWNFIELD_BRIDGE_DEEPLINK_TYPE.quitSmoking]: '/quit-smoking',
  [BROWNFIELD_BRIDGE_DEEPLINK_TYPE.ePharmacy]: '/epharmacy',
  [BROWNFIELD_BRIDGE_DEEPLINK_TYPE.pushOptIn]: '/push-opt-in',
  [BROWNFIELD_BRIDGE_DEEPLINK_TYPE.profile]: '/profile',
  [BROWNFIELD_BRIDGE_DEEPLINK_TYPE.addFamilyMember]: '/add-family-member',
  [BROWNFIELD_BRIDGE_DEEPLINK_TYPE.today]: '/today',
  [BROWNFIELD_BRIDGE_DEEPLINK_TYPE.inbox]: '/inbox',
  [BROWNFIELD_BRIDGE_DEEPLINK_TYPE.account]: '/account',
} as const

export const DEEPLINK_URL_CONFIG_KEYS = {
  [BROWNFIELD_BRIDGE_DEEPLINK_TYPE.episode]: 'DEEPLINK_EPISODE',
  [BROWNFIELD_BRIDGE_DEEPLINK_TYPE.services]: 'DEEPLINK_SERVICES',
  [BROWNFIELD_BRIDGE_DEEPLINK_TYPE.physicalHealth]: 'DEEPLINK_PHYSICAL_HEALTH',
  [BROWNFIELD_BRIDGE_DEEPLINK_TYPE.mentalHealth]: 'DEEPLINK_MENTAL_HEALTH',
  [BROWNFIELD_BRIDGE_DEEPLINK_TYPE.diabetesCare]: 'DEEPLINK_DIABETES_CARE',
  [BROWNFIELD_BRIDGE_DEEPLINK_TYPE.respiratoryCare]: 'DEEPLINK_RESPIRATORY_CARE',
  [BROWNFIELD_BRIDGE_DEEPLINK_TYPE.quitSmoking]: 'DEEPLINK_QUIT_SMOKING',
  [BROWNFIELD_BRIDGE_DEEPLINK_TYPE.ePharmacy]: 'DEEPLINK_EPHARMACY',
  [BROWNFIELD_BRIDGE_DEEPLINK_TYPE.ePharmacyTrackPrescriptionOrder]:
    'DEEPLINK_EPHARMACY_TRACK_PRESCRIPTION_ORDER',
  [BROWNFIELD_BRIDGE_DEEPLINK_TYPE.ePharmacyAddPrescription]: 'DEEPLINK_EPHARMACY_ADD_PRESCRIPTION',
  [BROWNFIELD_BRIDGE_DEEPLINK_TYPE.ePharmacyManageMedications]:
    'DEEPLINK_EPHARMACY_MANAGE_MEDICATIONS',
  [BROWNFIELD_BRIDGE_DEEPLINK_TYPE.ePharmacyChatPharmacy]: 'DEEPLINK_EPHARMACY_CHAT_PHARMACY',
  [BROWNFIELD_BRIDGE_DEEPLINK_TYPE.ePharmacyCarePlan]: 'DEEPLINK_EPHARMACY_CARE_PLAN',
  [BROWNFIELD_BRIDGE_DEEPLINK_TYPE.ePharmacyConsultation]: 'DEEPLINK_EPHARMACY_CONSULTATION',
  [BROWNFIELD_BRIDGE_DEEPLINK_TYPE.pushOptIn]: 'DEEPLINK_PUSH_OPT_IN',
  [BROWNFIELD_BRIDGE_DEEPLINK_TYPE.profile]: 'DEEPLINK_PROFILE',
  [BROWNFIELD_BRIDGE_DEEPLINK_TYPE.addFamilyMember]: 'DEEPLINK_ADD_FAMILY_MEMBER',
  [BROWNFIELD_BRIDGE_DEEPLINK_TYPE.today]: 'DEEPLINK_TODAY',
  [BROWNFIELD_BRIDGE_DEEPLINK_TYPE.inbox]: 'DEEPLINK_INBOX',
  [BROWNFIELD_BRIDGE_DEEPLINK_TYPE.account]: 'DEEPLINK_ACCOUNT',
} as const

export const DEEPLINK_TEMPLATE_PARAMS = {
  [BROWNFIELD_BRIDGE_DEEPLINK_TYPE.episode]: ['episodeId'],
} as const

export type DeeplinkUrlsConfig = Record<string, string>

type BridgeDeeplinkEnvConfig = {
  BRIDGE_DEEPLINK_URLS_BY_ENV?: Partial<
    Record<'development' | 'test' | 'production', DeeplinkUrlsConfig>
  >
}

function getEnvironmentName(): 'development' | 'test' | 'production' {
  if (process.env.NODE_ENV === 'test') return 'test'
  if (__DEV__) return 'development'
  return 'production'
}

export function resolveDeeplinkUrlsConfig(): DeeplinkUrlsConfig | undefined {
  const env = getEnvironmentName()
  const envUrls = (Config as typeof Config & BridgeDeeplinkEnvConfig).BRIDGE_DEEPLINK_URLS_BY_ENV?.[
    env
  ]

  return envUrls ?? Config.BRIDGE_DEEPLINK_URLS
}
